export default __webpack_public_path__ + "static/media/ABW.630989eb.svg";